<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content badge-content" v-loading.lock="loading">
        <div class="go-back" @click="goBack">返回</div>
        <div class="badge-title">扫一扫</div>
        <div class="badge-infor">
          <div class="badge-left">
            <div class="title">
              主开通人（主开通人是企业展后接收数据的唯一邮箱）
            </div>
            <div class="add-user">
              <div
                class="add-icon"
                @click="drawerEditMask = true"
                v-if="ruleForm.badge_long_id == ''"
              >
                <div><i class="el-icon-plus"></i></div>
                <div>添加联系人</div>
              </div>
              <div class="user-infor" v-else>
                <div
                  class="title-btn"
                  @click="drawerEditMask = true"
                  v-if="ruleForm.badge_long_id"
                >
                  修改信息
                </div>
                <div>姓名：{{ mainData.nickname }}</div>
                <div>证件号：{{ mainData.id_number }}</div>
                <div>手机号：{{ mainData.tel }}</div>
                <div>邮箱：{{ mainData.email }}</div>
                <div>接收数据邮箱:{{ mainData.receive_email }}</div>
              </div>
            </div>
          </div>
          <div class="badge-right">
            <p>温馨提示：</p>
            <p>
              1.该功能是专门供药交会/健康营养展的展商收集展会观众数据，帮助企业进行展后分析的工具。
            </p>
            <p>
              2.以下信息填写请确保使用者是经企业确认的人员，且信息真实、有效。不得出售、转让使用权，如有不妥主办有权不提供展后数据。
            </p>
            <p>
              3.主开通人申请后如需要修改则上传加盖公司公章的说明，请提前准备好再进行申请。
            </p>
            <p>
              免责声明：如因企业自身问题，开通人的邮箱输入错误，转让收集邮箱，收集人不是企业在职人员等因素导致的数据泄露，主办方不承担任何责任。
            </p>
            <br />
            <p class="red">重要提示：</p>
            <!--<p class="red">1、设置主次开通人总数不超过4人。</p> -->
            <p class="red">
              1. 次开通人需从当届现有胸卡列表选取，新增请至胸卡管理。
            </p>
            <p class="red">
              2. 次开通人选择成功时状态栏显示“<i
                style="font-size: 20px; color: #52c41a; font-weight: bold"
                class="el-icon-check"
              ></i
              >”。
            </p>
          </div>
        </div>
        <!-- 胸卡列表 -->
        <div class="badge-table">
          <div
            class="title"
            style="
              margin-bottom: 15px;
              padding-bottom: 14px;
              border-bottom: 1px solid #f0f2f5;
            "
          >
            次开通人（次开通人是企业制定的数据收集者，不具备数据接收功能）
            <div class="search-wrap">
              <el-input
                v-model="search.nickname"
                placeholder="输入姓名搜索"
                prefix-icon="el-icon-search"
                clearable
              ></el-input>
              <div class="search-btn" @click="searchHandle">搜索</div>
            </div>
          </div>
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <!-- <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column label="ID" prop="id" width="70"></el-table-column> -->
            <el-table-column label="选择次开通人" prop="email" min-width="80">
              <template slot-scope="scope">
                <div class="icon-wrap">
                  <i
                    v-if="scope.row.is_identity == 0"
                    class="el-icon-close"
                    @click="setBadgeHandle(2, scope.row)"
                  ></i>
                  <i
                    v-if="scope.row.is_identity == 2"
                    class="el-icon-check"
                    @click="setBadgeHandle(0, scope.row)"
                  ></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="姓名"
              prop="nickname"
              min-width="80"
            ></el-table-column>
            <el-table-column
              label="手机"
              prop="tel"
              min-width="110"
            ></el-table-column>
            <el-table-column
              label="证件号"
              prop="id_number"
              min-width="170"
            ></el-table-column>
            <el-table-column
              label="邮箱"
              prop="email"
              min-width="100"
            ></el-table-column>
            <el-table-column
              label="部门"
              prop="department"
              min-width="80"
            ></el-table-column>
            <el-table-column
              label="职位"
              prop="position"
              min-width="90"
            ></el-table-column>
            <!-- <el-table-column label="操作" width="100" fixed="right">
              <template slot-scope="scope">
                <span class="check-btn" @click="edit(scope.row)">查看</span>
              </template>
            </el-table-column> -->
          </el-table>
          <div class="pagination_box">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="totals"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 主开通人详情 -->
      <el-dialog
        :title="ruleForm.badge_long_id ? '修改联系人' : '添加联系人'"
        :visible.sync="drawerEditMask"
        width="40%"
        :close-on-click-modal="false"
      >
        <div class="badge-details">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="110px"
            label-position="right"
            class="demo-ruleForm"
          >
            <el-form-item label="联系人" prop="nickname">
              <el-select
                v-model="ruleForm.nickname"
                filterable
                placeholder="请选择"
                @blur="handleInput"
                @change="handleChange"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in badgOption"
                  :key="item.badge_long_id"
                  :label="item.nickname"
                  :value="item.badge_long_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="手机号" prop="tel">
              <el-input v-model="ruleForm.tel"></el-input>
            </el-form-item>
            <el-form-item label="证件号" prop="id_number">
              <el-input v-model="ruleForm.id_number"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
            <el-form-item label="部门" prop="department">
              <el-input v-model="ruleForm.department"></el-input>
            </el-form-item>
            <el-form-item label="职务" prop="position">
              <el-input v-model="ruleForm.position"></el-input>
            </el-form-item>
            <el-form-item label="省份" prop="province">
              <el-select
                v-model="ruleForm.province"
                placeholder="请选择"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in areaOption"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="接收数据邮箱" prop="receive_email">
              <el-input v-model="ruleForm.receive_email"></el-input>
            </el-form-item>
            <el-form-item
              v-if="ruleForm.badge_long_id"
              label="资料变更说明"
              prop="modify_file"
            >
              <!-- <div class="data-change">
                <div class="change-btn">
                  <img :src="addIcon" alt="" /> 上传文件
                </div>
                <span>上传盖章证明</span>
              </div> -->
              <div class="image-wrap" v-if="ruleForm.modify_file">
                <div class="image">
                  <el-image :src="$imgOssUrl + ruleForm.modify_file"></el-image>
                  <div class="upload-span">
                    <span class="upload-icon" @click.stop="handleRemove"
                      ><i class="el-icon-delete"></i
                    ></span>
                  </div>
                </div>
              </div>
              <div v-if="ruleForm.modify_file == ''">
                <el-upload
                  :action="$Url"
                  list-type="picture-card"
                  :headers="headers"
                  :multiple="false"
                  :on-progress="handleProgress"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :show-file-list="false"
                >
                  <div v-if="!progressVisible">
                    <i class="el-icon-plus" style="font-size: 14px"></i
                    >上传盖章证明
                  </div>
                  <div v-if="progressVisible" style="padding-top: 30px">
                    <el-progress
                      :percentage="progressPercent"
                      type="circle"
                      :width="80"
                    ></el-progress>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-form>
          <div class="tips" v-if="ruleForm.badge_long_id">
            修改主开通人需要提供主开通人资料变更说明
            <a
              href="https://oss.file.pharmchina.com.cn/larspring/%E6%89%AB%E4%B8%80%E6%89%AB%E5%8A%9F%E8%83%BD%E4%B8%BB%E5%BC%80%E9%80%9A%E4%BA%BA%E5%8F%98%E6%9B%B4%E8%AF%B4%E6%98%8E.docx"
              >《说明参考》点击下载</a
            >
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="drawerEditMask = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 次开通人详情 -->
      <el-dialog
        title="次开通人信息"
        :visible.sync="drawerNoticeEditMask"
        width="40%"
        :close-on-click-modal="false"
      >
        <div class="badge-details">
          <el-form
            :model="ruleNoticeForm"
            ref="ruleForm"
            label-width="100px"
            label-position="right"
            class="demo-ruleForm"
          >
            <el-form-item label="姓名" prop="nickname">
              <el-input v-model="ruleNoticeForm.nickname"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="id_number">
              <el-input v-model="ruleNoticeForm.id_number"></el-input>
            </el-form-item>
            <el-form-item label="部门" prop="department">
              <el-input v-model="ruleNoticeForm.department"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="position">
              <el-input v-model="ruleNoticeForm.position"></el-input>
            </el-form-item>
            <el-form-item label="子公司" prop="child_company">
              <el-input v-model="ruleNoticeForm.child_company"></el-input>
            </el-form-item>
            <el-form-item label="手机" prop="tel">
              <el-input v-model="ruleNoticeForm.tel"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="ruleNoticeForm.email"></el-input>
            </el-form-item>
          </el-form>
          <div style="color: red; text-align: center">
            如需修改次开通人信息，请在胸卡列表进行信息修改
          </div>
        </div>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="drawerEditMask = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确 定</el-button
          >
        </span> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getBadgeMainDetail,
  editBadgeMain,
  getBadgeMainOption,
  addBadgeMain,
  getBadgeNoticeLists,
  upbadgeNotice,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "scan",
  data() {
    return {
      loading: false,
      addIcon: require("../assets/add_icon.png"),
      active: 3,
      tableData: [],
      totals: 0,
      drawerEditMask: false,
      areaOption: [],
      badgOption: [],
      ruleForm: {
        badge_long_id: "",
        nickname: "",
        tel: "",
        id_number: "",
        email: "",
        department: "",
        position: "",
        country: "中国",
        province: "",
        receive_email: "",
        modify_file: "",
      },
      rules: {
        nickname: [
          { required: true, message: "请选择联系人", trigger: "change" },
        ],
        tel: [
          { required: true, message: "请输入手机", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
        id_number: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          {
            pattern:
              /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/,
            message: "请输入正确的身份证号码",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        department: [
          { required: true, message: "请输入部门", trigger: "blur" },
        ],
        position: [{ required: true, message: "请输入职位", trigger: "blur" }],
        province: [
          { required: true, message: "请选择省份", trigger: "change" },
        ],
        receive_email: [
          { required: true, message: "请输入接收数据邮箱", trigger: "blur" },
        ],
        modify_file: [
          { required: true, message: "请上传资料变更说明", trigger: "blur" },
        ],
      },
      multipleSelection: [],
      isShowBtn: false,
      isShowImportBtn: false,
      headers: {},
      lastValidValue: "", // 用于存储上一个有效值
      mainData: {},
      progressVisible: false,
      progressPercent: 0,
      page: 1,
      pageSize: 10,
      drawerNoticeEditMask: false,
      ruleNoticeForm: {},
      search: {
        nickname: "",
      },
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "conference" && item.id == 11;
    });
    this.active = index;
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    this.mark = this.$route.query.mark;
    //获取主开通人信息
    this.getMainDetail();
    //获取主开通人筛选项
    this.getBadgeOption();
    //获取展讯通列表
    this.getBadgeLists();
  },
  created() {},
  methods: {
    handleProgress(event, file, fileList) {
      // 显示进度条
      this.progressVisible = true;
      // 计算进度百分比
      this.progressPercent = Math.floor((event.loaded / event.total) * 100);
    },
    //资料变更上传成功
    handleSuccess(resData, file, fileList) {
      if (resData.code == 0) {
        this.$message.error(resData.msg);
        return false;
      }
      this.ruleForm.modify_file = resData.data.url;
      this.progressVisible = false;
    },
    // 资料变更上传失败
    handleError(err, file, fileList) {
      this.progressVisible = false;
      this.$message.error(err.message);
    },
    //资料变更删除
    handleRemove() {
      this.$alert("确定要删除吗!", "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            this.ruleForm.modify_file = "";
          }
        },
      });
    },
    handleInput(e) {
      this.ruleForm.nickname = e.target.value;
      this.ruleForm.tel = "";
      this.ruleForm.id_number = "";
      this.ruleForm.email = "";
      this.ruleForm.department = "";
      this.ruleForm.position = "";
      this.ruleForm.country = "中国";
      this.ruleForm.province = "";
      this.ruleForm.receive_email = "";
      this.$forceUpdate();
    },
    handleChange(val) {
      let index = this.badgOption.findIndex((item) => {
        return item.badge_long_id == val;
      });
      if (index == -1) {
        this.ruleForm.nickname = "";
        this.ruleForm.tel = "";
        this.ruleForm.id_number = "";
        this.ruleForm.email = "";
        this.ruleForm.department = "";
        this.ruleForm.position = "";
        this.ruleForm.country = "中国";
        this.ruleForm.province = "";
        this.ruleForm.receive_email = "";
      } else {
        let data = this.badgOption[index];
        this.ruleForm.nickname = data.nickname;
        this.ruleForm.tel = data.tel;
        this.ruleForm.id_number = data.id_number;
        this.ruleForm.email = data.email;
        this.ruleForm.department = data.department;
        this.ruleForm.position = data.position;
        this.ruleForm.country = "中国";
        this.ruleForm.province = data.province;
        this.ruleForm.receive_email = data.receive_email;
      }
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    //获取主开通人筛选项
    getBadgeOption() {
      getBadgeMainOption({})
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            this.areaOption = data.areaOption;
            this.badgOption = data.badgOption;
          }
        })
        .catch((err) => {});
    },
    //获取主开通人信息
    getMainDetail() {
      this.loading = true;
      getBadgeMainDetail({})
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            if (data.badge_long_id) {
              this.mainData = data;
              this.ruleForm.badge_long_id = data.badge_long_id;
              this.ruleForm.nickname = data.nickname;
              this.ruleForm.tel = data.tel;
              this.ruleForm.id_number = data.id_number;
              this.ruleForm.email = data.email;
              this.ruleForm.department = data.department;
              this.ruleForm.position = data.position;
              this.ruleForm.province = data.province;
              this.ruleForm.receive_email = data.receive_email;
            }

            this.loading = false;
          }
        })
        .catch((err) => {});
    },
    //搜索
    searchHandle() {
      this.page = 1;
      this.getBadgeLists();
    },
    //获取展讯通列表
    getBadgeLists() {
      let data = this.$qs.stringify({
        page_no: this.page,
        page_size: this.pageSize,
        nickname: this.search.nickname
      });
      getBadgeNoticeLists(data)
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            this.totals = data.count;
            this.tableData = data.lists;
          }
        })
        .catch((err) => {});
    },
    //列表是否选择
    setBadgeHandle(val, row) {
      upbadgeNotice({
        val,
        ids: row.badge_long_id,
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.getBadgeLists();
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((err) => {});
    },
    //多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 编辑
    edit(row) {
      this.drawerNoticeEditMask = true;
      this.ruleNoticeForm.nickname = row.nickname;
      this.ruleNoticeForm.id_number = row.id_number;
      this.ruleNoticeForm.tel = row.tel;
      this.ruleNoticeForm.position = row.position;
      this.ruleNoticeForm.department = row.department;
      this.ruleNoticeForm.email = row.email;
      this.ruleNoticeForm.child_company = row.child_company;
    }, // 删除
    del(row) {
      this.$alert(`确定要删除吗？`, "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            delBadge({ badge_long_id: row.badge_long_id })
              .then((res) => {
                if (res.data.code == 1) {
                  this.$message.success(res.data.msg);
                }
              })
              .catch((err) => {
                console.log(err, "===err");
              });
          }
        },
      });
    },
    // 分页相关
    handleCurrentChange(val) {
      this.page = val;
      this.getBadgeLists();
    },
    //胸卡详情保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.badge_long_id) {
            this.saveEditBadge();
          } else {
            this.saveAddBadge();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //编辑联系人信息
    saveEditBadge() {
      let data = this.ruleForm;
      editBadgeMain(data)
        .then((res) => {
          if (res.data.code == 1) {
            // this.$message.success(res.data.msg);
            // this.getMainDetail();
            this.drawerEditMask = false;
            this.$router.push({
              path: "/scanSuccess",
            });
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //添加胸卡
    saveAddBadge() {
      let data = this.ruleForm;
      addBadgeMain(data)
        .then((res) => {
          if (res.data.code == 1) {
            //this.$message.success(res.data.msg);
            this.drawerEditMask = false;
            this.$router.push({
              path: "/scanSuccess",
            });
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //文件上传成功
    handleFileSuccess(resData, file, fileList) {
      if (resData.code == 1) {
        this.$alert(resData.data.msg, "", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (action == "confirm") {
            }
          },
        });
      } else {
        this.$alert(resData.data.msg, "", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (action == "confirm") {
            }
          },
        });
      }
    },
    //文件上传失败
    handleFileError(err, file, fileList) {
      this.$alert(err.message, "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table th > .cell {
  white-space: pre-wrap;
}
/deep/ .el-table th {
  background: #edf1f7;
}
/deep/ .el-table td,
/deep/ .el-table th {
  text-align: center;
}
.image {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: relative;
  /deep/ .el-image {
    width: 148px;
    height: 148px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    .el-image__inner {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;
    border-radius: 6px;
    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }
  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}
.badge-content {
  .badge-title {
    font-weight: 500;
    font-size: 16px;
    color: #354052;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
    .create-wrap {
      display: flex;
    }
    .badge-create {
      min-width: 103px;
      height: 36px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
      border-radius: 4px;
      margin-left: 10px;
      padding: 0 10px;
      box-sizing: border-box;
      background: linear-gradient(270deg, #fe4d34 0%, #fc933f 100%);
    }
    .badge-bg {
      background: #fc933f;
    }
  }
  .badge-infor {
    display: flex;
    font-size: 14px;
    color: #1d1d1d;
    line-height: 23px;
    padding: 30px 20px;
    background: #fff;
    border-radius: 10px;
    margin: 30px 0 15px;
    .title {
      font-size: 14px;
      color: #354052;
      line-height: 24px;
    }
    .badge-left {
      width: 360px;
      margin-right: 50px;
    }
    .badge-right {
      flex: 1;
      .red {
        color: #ff4d4f;
      }
    }
    .add-user {
      margin-top: 7px;
      .add-icon {
        width: 137px;
        height: 137px;
        text-align: center;
        padding: 37px 0 35px;
        box-sizing: border-box;
        background: #f9f9f9;
        border-radius: 2px;
        font-size: 12px;
        color: rgba(67, 67, 67, 0.88);
        line-height: 24px;
        border: 1px dashed #bfbfbf;
        cursor: pointer;
        .el-icon-plus {
          font-size: 27px;
          margin-bottom: 8px;
          color: rgba(0, 0, 0, 0.45);
        }
      }
      .user-infor {
        width: 360px;
        min-height: 191px;
        padding: 15px 15px 5px 15px;
        font-size: 14px;
        color: #1d1d1d;
        line-height: 20px;
        box-sizing: border-box;
        background: #f3f5fb;
        border-radius: 6px;
        margin-top: 15px;
        position: relative;
        .title-btn {
          width: 58px;
          height: 22px;
          background: #fc933f;
          color: #fff;
          font-size: 12px;
          text-align: center;
          line-height: 22px;
          cursor: pointer;
          border-radius: 5px;
          position: absolute;
          top: 10px;
          right: 10px;
        }
        div {
          margin-bottom: 10px;
        }
      }
    }
  }
  .badge-table {
    padding: 30px 20px;
    background: #fff;
    border-radius: 18px;
    .title {
      font-size: 14px;
      color: #354052;
      line-height: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .search-wrap {
        display: flex;
        .search-btn {
          width: 103px;
          height: 40px;
          color: #fff;
          font-size: 14px;
          line-height: 40px;
          text-align: center;
          background: #fc933f;
          border-radius: 3px;
          cursor: pointer;
          margin-left: 10px;
        }
      }
    }
    .el-table {
      /deep/ .el-table__body-wrapper {
        min-height: 300px;
      }
    }
    .icon-wrap {
      font-size: 20px;
      .el-icon-close {
        color: #eb4141;
        font-weight: bold;
      }
      .el-icon-check {
        color: #52c41a;
        font-weight: bold;
      }
    }
    .check-btn {
      color: #3d83e9;
      cursor: pointer;
      font-weight: 500;
    }
    .check-btn:hover {
      text-decoration: underline;
    }
    .check-del {
      color: #ff4d4f;
    }
    .pagination_box {
      display: flex;
      align-items: center;
      justify-content: right;
      margin-top: 50px;
    }
  }
  .pagination_btn_wrap {
    display: flex;
    flex-wrap: wrap;
    position: fixed;
    bottom: 20px;
    z-index: 99;
    .pagination_btn {
      color: #fff;
      height: 32px;
      font-size: 14px;
      cursor: pointer;
      line-height: 32px;
      padding: 0 12px;
      border-radius: 4px;
      background: #3d83e9;
      margin-top: 10px;
      margin-right: 10px;
    }
  }
}
.badge-details {
  padding: 0 30px;
  .details-title {
    font-size: 16px;
    font-weight: 500;
    color: #3d83e9;
    padding-bottom: 20px;
    border-bottom: 1px solid #3d83e9;
  }
  .tips {
    font-size: 14px;
    color: #666;
    line-height: 20px;
    text-align: center;
    a {
      color: #409eff;
      text-decoration: underline;
    }
  }
  .demo-ruleForm {
    padding: 10px 70px 10px 0;
    .data-change {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: rgba(153, 153, 153, 0.88);
      .change-btn {
        font-size: 14px;
        width: 106px;
        height: 40px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        border-radius: 6px;
        margin-right: 10px;
        color: rgba(0, 0, 0, 0.88);
        border: 1px solid #dddfe6;
        img {
          width: 15px;
          margin-right: 5px;
        }
      }
    }
  }
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff;
}
/deep/ .el-table td,
/deep/ .el-table th.is-leaf {
  border-bottom: 0 none;
}
/* 表格最外层边框-底部边框 */
/deep/ .el-table--border::after,
/deep/ .el-table--group::after {
  width: 0;
}
/deep/ :focus {
  outline: 0;
}
/deep/ .el-drawer__header {
  font-size: 18px;
  color: #333;
  font-weight: 500;
}
/deep/ .el-dialog__body {
  height: 500px;
  overflow-y: scroll;
}
@media only screen and (max-width: 1339px) {
  .badge-content .badge-search .search-item {
    width: 21%;
  }
  .badge-content .badge-search .search-btn-wrap {
    width: calc(84% + 72px);
    display: flex;
    justify-content: end;
  }
}
@media only screen and (max-width: 1060px) {
  .badge-content .badge-search .search-item {
    width: 45%;
  }
  .badge-content .badge-search .search-btn-wrap {
    width: calc(90% + 24px);
    display: flex;
    justify-content: end;
  }
  .badge-content .badge-infor {
    flex-wrap: wrap;
    .badge-div,
    .badge-code {
      width: 100%;
    }
    .badge-code {
      margin-top: 20px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .content {
    margin: 0;
    padding: 20px;
  }
  .badge-content .badge-search .search-item {
    width: 100%;
    margin-right: 0;
  }
  .badge-content .badge-table .pagination_box .pagination_left {
    flex-wrap: wrap;
  }
  .badge-content .badge-table .pagination_box .pagination_left .pagination_btn {
    margin-bottom: 10px;
  }
  .pagination_box {
    flex-wrap: wrap;
    .el-pagination {
      width: 100%;
      padding: 20px 0;
      text-align: right;
    }
  }
  /deep/ .el-dialog {
    width: 90% !important;
  }
  .badge-details {
    padding: 0;
    .demo-ruleForm {
      padding: 0;
    }
  }
}
</style>